<template>
  <div class="sidebar-summary">
    <div
      v-if="currentOrderStep > '0' && currentOrderStep !== '1'"
      class="sidebar-summary__item"
    >
      <h4>Lieferadresse</h4>
      <ul>
        <li>
          <span
            v-if="order.billing_address.street == order.delivery_address.street"
            >{{ fullName }}</span
          >
          <span v-else>{{ order.contact_person }}</span>
        </li>
        <li v-if="order.company.name">{{ order.company.name }}</li>
        <li>{{ order.delivery_address.street }}</li>
        <li>
          {{ order.delivery_address.zip }} {{ order.delivery_address.city }}
        </li>
      </ul>
      <button class="edit-btn" type="button" @click="$emit('editData')">
        bearbeiten
      </button>
    </div>
    <div v-if="currentOrderStep > '0' && currentOrderStep !== '1' && commercialBuyer" class="sidebar-summary__item">
        <h4>Bereitstellungspauschale</h4>
        <dl>
          <div>
            <dt>
              Einmalige Pauschale <i class="fas fa-info-circle" @click="openFleetModal" style="cursor:pointer" />
            </dt>
            <dd><strong>€ {{commitmentFee}} ,- </strong><span class="mwst block">inkl. Mwst.</span></dd>
          </div>
        </dl>
        <button class="edit-btn" type="button" @click="$emit('editData')">
          bearbeiten
        </button>
      </div>
    <div v-if="currentOrderStep > '2a'" class="sidebar-summary__item">
      <h4>Garantie</h4>
      <dl>
        <div v-if="order.warranty_extension === 'basic'">
          <dt>PKW.de-Garantie</dt>
          <dd><strong>€ 0 ,- </strong></dd>
        </div>
        <div v-else-if="order.warranty_extension === 'classic'">
          <dt>Klassik-Schutz</dt>
          <dd><strong>€ 150 ,- </strong><span class="mwst block">inkl. Mwst.</span></dd>
        </div>
        <div v-else-if="order.warranty_extension === 'premium'">
          <dt>Premium-Schutz</dt>
          <dd><strong>€ 270 ,- </strong><span class="mwst block">inkl. Mwst.</span></dd>
        </div>
        <div v-else-if="order.warranty_extension === 'premium_plus'">
          <dt>Premium-Plus-Schutz</dt>
          <dd><strong>€ 680 ,- </strong><span class="mwst block">inkl. Mwst.</span></dd>
        </div>
      </dl>
      <p v-if="order.car_insurance">mit Autoversicherung</p>
      <button class="edit-btn" type="button" @click="$emit('editWarranty')">
        bearbeiten
      </button>
    </div>
    <div v-if="currentOrderStep > '2b'" class="sidebar-summary__item">
      <h4>Autoversicherung</h4>
      <dl>
        <div v-if="order.friday_insurance === true">
          <p>
            <b>Ja</b>, ich bin an einem <b>unverbindlichen Angebot</b> für eine
            Autoversicherung interessiert.
          </p>
        </div>
        <div v-else>
          <p>
            <b>Nein</b>, ich möchte kein Angebot zur Autoversicherung erhalten.
          </p>
        </div>
      </dl>
      <button
        class="edit-btn"
        type="button"
        @click="$emit('editFridayWarranty')"
      >
        bearbeiten
      </button>
    </div>
    <div v-if="currentOrderStep > '3'" class="sidebar-summary__item">
      <div v-if="order.payment_method === 'self_pay'">
        <h4>Barkauf</h4>
        <p>
          Zahlung des kompletten Fahrzeugpreises erfolgt nach Vertragsabschluss
          via Überweisung.
        </p>
      </div>
      <div v-else>
        <h4>Finanzierung</h4>
        <p>Gleichbleibend {{ withBallon ? "mit" : "ohne" }} Schlussrate</p>
        <dl>
          <div>
            <dt>Einmalige Anzahlung</dt>
            <dd>{{ formattedPrice(order.first_payment_raw, 2) }}</dd>
          </div>
          <div>
            <dt>Schlussrate (letzte Rate)</dt>
            <dd>{{ formattedPrice(order.last_payment_raw, 2) }}</dd>
          </div>
          <div>
            <dt>Mtl. Rate à</dt>
            <dd>{{ formattedPrice(order.monthly_rate_raw, 2) }}</dd>
          </div>
        </dl>
      </div>
      <button class="edit-btn" type="button" @click="$emit('editFinancing')">
        bearbeiten
      </button>
    </div>
    <div v-if="currentOrderStep > '4a'" class="sidebar-summary__item">
      <h4>Fahrzeugzulassung</h4>
      <p v-if="financingEdited" class="edited-msg">
        Wir haben die Zulassungsart geändert, da Sie Ihre Zahlungsart geändert
        haben. Eine Selbst-Zulassung ist nur bei Barkauf möglich.
      </p>
      <dl>
        <div>
          <dt>
            {{
              order.registration_service === STANDARD ? "Zulassung durch PKW.de" :
              order.registration_service === WITH_PLATES ? "Zulassung durch PKW.de mit Wunschkennzeichen" :
              order.registration_service === SELF ? "Selbst-Zulassung" :
              "Unknown Service"
            }}
          </dt>
          <dd v-if="!commercialBuyer">
            €
            {{
              notCommercialPrice
            }}
            ,- <span v-if="notCommercialPrice !== 0" class="mwst block">inkl. Mwst.</span>
          </dd>
          <dd v-else>
            €
            {{
              commercialPrice
            }}
            ,- <span v-if="commercialPrice !== 0" class="mwst block">inkl. Mwst.</span>
          </dd>
        </div>
      </dl>
      <button class="edit-btn" type="button" @click="$emit('editApproval')">
        bearbeiten
      </button>
    </div>
    <div v-if="currentOrderStep >= '5'" class="sidebar-summary__item">
      <h4>Lieferoptionen</h4>
      <dl>
        <div v-if="order.delivery_method === 'standard'">
          <dt>Auf eigener Achse</dt>
          
          <dd v-if="commercialBuyer">ab € {{ order.car_info.online_offer_services.all_services_b2b.delivery.transporter }} ,- <span class="mwst block">inkl. Mwst.</span></dd>
          <dd v-else>€ 0 ,-</dd>
        </div>
        <div v-else>
          <dt>Überführung per Spedition</dt>
          <dd v-if="!commercialBuyer">ab € {{ order.car_info.online_offer_services.all_services.delivery.transporter }} ,- <span class="mwst block">inkl. Mwst.</span></dd>
          <dd v-else>ab € {{ order.car_info.online_offer_services.all_services_b2b.delivery.transporter }} ,- <span class="mwst block">inkl. Mwst.</span></dd>
        </div>
      </dl>
      <button class="edit-btn" type="button" @click="$emit('editDelivery')">
        bearbeiten
      </button>
    </div>
    <div v-if="currentOrderStep >= '5'" class="sidebar-summary__item">
      <h4>Winterreifen auf Stahlfelgen</h4>
      <div v-if="order.winter_tires_option === 'economy'">
        <div style="display:flex;margin-bottom:10px;">
          <div>
            <p><b>Economy-Winterreifen</b></p>
            <p>
              Sicherheit bei Schnee und Glätte - zum optimalen
              Preis-Leistungsverhältnis
            </p>
          </div>
        </div>
      </div>
      <div v-if="order.winter_tires_option === 'premium'">
        <div style="display:flex;margin-bottom:10px;">
          <div>
            <p>
              <b>Premium-Winterreifen</b>
            </p>
            <p>
              Markenqualität von Premiumherstellern - getestete Sicherheit der
              Spitzenklasse
            </p>
          </div>
        </div>
      </div>
      <div v-if="order.winter_tires_option === 'none'">
        <div style="display:flex;margin-bottom:10px;">
          <div>
            <p><b>Keine Winterräder</b></p>
            <p>
              Ich möchte keine Winterräder. Witterungsbedingte Verzögerungen bei
              der Lieferung meines Wunschfahrzeugs nehme ich in Kauf
            </p>
          </div>
        </div>
      </div>
      <button class="edit-btn" type="button" @click="$emit('editDelivery')">
        bearbeiten
      </button>
    </div>
    <FleetHubModal :isOpen="showFleetHubModal" :closeModal="closeFleetModal" />
  </div>
</template>

<script>
import FleetHubModal from "./modals/FleetHubModal.vue";
import { formatPrice } from "@/utils/price-helpers";
import { SELF, STANDARD, WITH_PLATES } from "./ApprovalPkwForm.vue";

export default {
  props: [
    "car",
    "order",
    "currentOrderStep",
    "title",
    "hideDetails",
    "financingEdited",
  ],
  data() {
    return {
      showModal: false,
      SELF, STANDARD, WITH_PLATES,
      showFleetHubModal: false,
    };
  },
  components: {
    FleetHubModal
  },
  computed: {
    carPrice() {
      return this.order
        ? this.order.car_info.price.customer
        : this.car.price.customer;
    },
    withBallon() {
      return this.order.last_payment_raw !== 0;
    },
    fullName() {
      const { name, surname, gender } = this.order;
      const genderTitle = { male: "Herr", female: "Frau", diverse: "Divers" };
      return `${genderTitle[gender]} ${name} ${surname}`;
    },
    privateBuyer() {
      return (this.order.private_buyer ? 'private' : 'comercial') || '';
    },
    commercialBuyer() {
      return this.privateBuyer == 'comercial';
    },
    commitmentFee() {
      return this.car.online_offer_services?.all_services_b2b.operations.commitment_fee;
    },
    notCommercialPrice() {
      return this.order.registration_service === STANDARD ? this.order.car_info.online_offer_services.all_services.registration.standard :
              this.order.registration_service === WITH_PLATES ? this.order.car_info.online_offer_services.all_services.registration.standard_with_license_plate :
              this.order.registration_service === SELF ? this.order.car_info.online_offer_services.all_services.registration.self :
              "Unknown Price"
    },
    commercialPrice() {
      return this.order.registration_service === STANDARD ? this.order.car_info.online_offer_services.all_services_b2b.registration.standard :
              this.order.registration_service === WITH_PLATES ? this.order.car_info.online_offer_services.all_services_b2b.registration.standard_with_license_plate :
              this.order.registration_service === SELF ? this.order.car_info.online_offer_services.all_services_b2b.registration.self :
              "Unknown Price"
    }
  },
  methods: {
    formattedPrice(num) {
      return `€ ${formatPrice(num)} ,-`;
    },
    openFleetModal() { 
      this.showFleetHubModal = true;
    },
    closeFleetModal() {
      this.showFleetHubModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-summary {
  &__item {
    position: relative;
    padding: 25px;
    margin-bottom: 20px;
    border: 1px solid #d6d6d6;
    font-size: 16px;
    .edited-msg {
      color: $red;
    }
    h4 {
      margin-bottom: 10px;
      font-size: 18px;
    }
    li {
      margin-bottom: 10px;
    }
    dl {
      > div {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
      }
      dt {
        width: 166px;
      }
      dd {
        margin-left: 10px;
      }
    }
    button {
      font-size: 14px;
      color: $red;
    }
  }
}
</style>
